import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./context/UserContext";
import logo from "../assets/goatt_web_grnn.webp";
import "./styles/Header.css";

function Header() {
  const { user, logoutUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  //  Go to user profile (based on role)
  const goToUserProfile = () => {
    if (!user) return;

    const profilePath =
      user.role === "tutor" ? "/tutor/profile" : "/student/profile";

    navigate(profilePath);
    window.scrollTo(0, 0);
    setMobileMenuOpen(false);
  };

  const goToSubmission = () => {
    navigate("/tutor-submission");
  };

  //  Logout
  const handleLogout = () => {
    logoutUser();
    navigate("/login");
    setMobileMenuOpen(false);
    console.log("User logged out successfully!");
  };

  //  Mobile menu toggle
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="uber-header">
      <div className="header-container">
        {/* Left section - Logo */}
        <div className="header-left">
          <a href="/" className="logo-container">
            <img src={logo} alt="GOATT Logo" className="logo" />
          </a>
        </div>

        {/* Right section - Auth buttons */}
        <div className="header-right">
          <nav className="main-nav">
            <ul className="nav-links">
              <li>
                <a href="/">হোম</a>
              </li>

              <li>
                <a href="/about">আমাদের সম্পর্কে</a>
              </li>
              <li>
                <a
                  href="/tutor-submission"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  টিউটর হও
                </a>
              </li>
              <li>
                <a
                  href="/post-tuition"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  টিউশন পোস্ট করো
                </a>
              </li>
            </ul>
          </nav>

          <div className="auth-buttons">
            {user ? (
              <>
                {/*  Profile (Secondary) */}
                <button
                  onClick={goToUserProfile}
                  className="ml-2 px-3 py-2 text-[12px] sm:px-4 sm:py-2 sm:text-[13px]
             font-bold rounded-full whitespace-nowrap
             text-white border border-white bg-transparent
             transition-all duration-200
             hover:bg-white hover:text-black
             hover:-translate-y-[1px] hover:shadow-[0_4px_10px_rgba(255,255,255,0.25)]
             active:translate-y-0"
                >
                  {user?.name?.split(" ")[0] || "Profile"}
                </button>

                {/*  Logout Button */}
                {/* <button className="auth-link" onClick={handleLogout}>
                  Log Out
                </button> */}

                {/* <div
                  aria-label="User Login Button"
                  tabIndex={0}
                  role="button"
                  className="user-profile"
                  onClick={handleLogout}
                >
                  <div className="user-profile-inner">
                    <svg
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <g data-name="Layer 2" id="Layer_2">
                        <path d="m15.626 11.769a6 6 0 1 0 -7.252 0 9.008 9.008 0 0 0 -5.374 8.231 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 9.008 9.008 0 0 0 -5.374-8.231zm-7.626-4.769a4 4 0 1 1 4 4 4 4 0 0 1 -4-4zm10 14h-12a1 1 0 0 1 -1-1 7 7 0 0 1 14 0 1 1 0 0 1 -1 1z" />
                      </g>
                    </svg>
                    <p className="asdffg">Log out</p>
                  </div>
                </div> */}
              </>
            ) : (
              <>
                {/*  Show Teach Now & Login when NOT logged in */}
                {/* <button
                  className="cursor-pointer text-white font-bold relative text-[14px] w-[6em] h-[2.2em] text-center bg-gradient-to-r from-violet-500 from-10% via-sky-500 via-30% to-pink-500 to-90% bg-[length:400%] rounded-[30px] z-10 hover:animate-gradient-xy hover:bg-[length:100%] before:content-[''] before:absolute before:-top-[5px] before:-bottom-[5px] before:-left-[5px] before:-right-[5px] before:bg-gradient-to-r before:from-violet-500 before:from-10% before:via-sky-500 before:via-30% before:to-pink-500 before:bg-[length:400%] before:-z-10 before:rounded-[35px] before:hover:blur-xl before:transition-all before:ease-in-out before:duration-[1s] before:hover:bg-[length:10%] active:bg-violet-700 focus:ring-violet-700"
                  onClick={() => {
                    goToSubmission();
                    window.scrollTo(0, 0);
                  }}
                >
                  টিউটর হও
                </button> */}

                <div
                  aria-label="User Login Button"
                  tabIndex={0}
                  role="button"
                  className="user-profile"
                  onClick={() => {
                    navigate("/login");
                    window.scrollTo(0, 0);
                  }}
                >
                  <div className="user-profile-inner">
                    <svg
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <g data-name="Layer 2" id="Layer_2">
                        <path d="m15.626 11.769a6 6 0 1 0 -7.252 0 9.008 9.008 0 0 0 -5.374 8.231 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 9.008 9.008 0 0 0 -5.374-8.231zm-7.626-4.769a4 4 0 1 1 4 4 4 4 0 0 1 -4-4zm10 14h-12a1 1 0 0 1 -1-1 7 7 0 0 1 14 0 1 1 0 0 1 -1 1z" />
                      </g>
                    </svg>
                    <p className="asdffg baloo-da-2-tutor">লগ ইন</p>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Mobile menu toggle */}
          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? "active" : ""}`}>
        <nav className="mobile-nav">
          <ul>
            <li>
              <a href="/">হোম</a>
            </li>

            {/*  Tutor Network Pro (Primary) */}
            {user?.role === "tutor" && (
              <li
                onClick={() => {
                  navigate("/packages");
                  window.scrollTo(0, 0);
                }}
                className=" baloo-da-2-tutor"
              >
                Get Tutor Pro
              </li>
            )}

            <li>
              <a href="/about">আমাদের সম্পর্কে</a>
            </li>
            <li>
              <a
                href="/tutor-submission"
                onClick={() => setMobileMenuOpen(false)}
              >
                টিউটর হও
              </a>
            </li>
            <li>
              <a href="/post-tuition" onClick={() => setMobileMenuOpen(false)}>
                টিউশন পোস্ট করো
              </a>
            </li>

            {user && (
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  লগ আউট
                </a>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
